import { render, staticRenderFns } from "./DetailCommande.vue?vue&type=template&id=3eeca940&scoped=true&"
import script from "./DetailCommande.js?vue&type=script&lang=js&"
export * from "./DetailCommande.js?vue&type=script&lang=js&"
import style0 from "./DetailCommande.scoped.scss?vue&type=style&index=0&id=3eeca940&lang=scss&scoped=true&"
import style1 from "./DetailCommande.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeca940",
  null
  
)

export default component.exports